'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _owl = require('@dp/owl');

var _owl2 = _interopRequireDefault(_owl);

var _environment = require('../lib/environment');

var _environment2 = _interopRequireDefault(_environment);

var _environments = require('../config/environments');

var environmentType = _interopRequireWildcard(_environments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (options) {
    window.Owl = _owl2.default;
    _owl2.default.start((0, _extends3.default)({ devMode: _environment2.default === environmentType.PRODUCTION }, options));
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/varyag-hoc-component/logger/owl.js
// module id = 264
// module chunks = 0